"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShowRegulatedSpacesBanner = exports.getShouldRenderDirectBookInDrawer = exports.getOpenSchedulingConfig = exports.showAvailableWithinDays = exports.getBookingStrategy = void 0;
const types_1 = require("../../types");
const utils_1 = require("../../lib/utils");
function getBookingStrategy(config, provider, availabilityProps) {
    var _a, _b;
    let bookingStrategy = types_1.BookingStrategies.Button;
    if ((_a = availabilityProps === null || availabilityProps === void 0 ? void 0 : availabilityProps.enabled) !== null && _a !== void 0 ? _a : false) {
        bookingStrategy = types_1.BookingStrategies.Availability;
    }
    if ((_b = config.third_party) === null || _b === void 0 ? void 0 : _b.mychart_open_scheduling) {
        if (config.third_party.mychart_open_scheduling.enabled) {
            if ((0, utils_1.isProviderCompatibleWithOpenScheduling)(config.third_party.mychart_open_scheduling, provider)) {
                return types_1.BookingStrategies.OpenSchedulingWidget;
            }
        }
    }
    return bookingStrategy;
}
exports.getBookingStrategy = getBookingStrategy;
function showAvailableWithinDays(props) {
    var _a, _b;
    if ((_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.hide_availability_density) !== null && _b !== void 0 ? _b : true) {
        return false;
    }
    if (props.availabilityDensityBest) {
        return true;
    }
    else {
        return false;
    }
}
exports.showAvailableWithinDays = showAvailableWithinDays;
function getOpenSchedulingConfig(config) {
    var _a;
    return (_a = config.third_party) === null || _a === void 0 ? void 0 : _a.mychart_open_scheduling;
}
exports.getOpenSchedulingConfig = getOpenSchedulingConfig;
function getShouldRenderDirectBookInDrawer(config) {
    var _a, _b;
    return (((_a = config === null || config === void 0 ? void 0 : config.direct_book) === null || _a === void 0 ? void 0 : _a.render_type) ||
        ((_b = config === null || config === void 0 ? void 0 : config.feature_flags) === null || _b === void 0 ? void 0 : _b.dbw_render_in_drawer) === true);
}
exports.getShouldRenderDirectBookInDrawer = getShouldRenderDirectBookInDrawer;
function getShowRegulatedSpacesBanner(config) {
    var _a;
    return ((_a = config === null || config === void 0 ? void 0 : config.direct_book) === null || _a === void 0 ? void 0 : _a.show_regulated_spaces_banner) || false;
}
exports.getShowRegulatedSpacesBanner = getShowRegulatedSpacesBanner;
//# sourceMappingURL=utilities.js.map